module.exports = __webpack_public_path__ + "assets/img/btn-view-a7b53e43.png";